// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import AddressSharedStyles from "@ces/App/SharedStyles/LocationPage/LocationAddressStyles";
import { pickUpLocationAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

pickUpLocationAddressInfoDisplayStyles.address = {
    ...AddressSharedStyles.address,
};
pickUpLocationAddressInfoDisplayStyles.editLink = {
    css: css`
        display: none;
    `,
};
pickUpLocationAddressInfoDisplayStyles.headingText = {
    variant: "h6",
    as: "p",
} as TypographyProps;

pickUpLocationAddressInfoDisplayStyles.headingGridItem = {
    width: 12,
};
